import { render } from "./CardPanel.vue?vue&type=template&id=21bc8bfe&scoped=true"
import script from "./CardPanel.vue?vue&type=script&lang=js"
export * from "./CardPanel.vue?vue&type=script&lang=js"

import "./CardPanel.vue?vue&type=style&index=0&id=21bc8bfe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bc8bfe"]])

export default __exports__